// Global event bus.
import Vue from 'vue';

export default new Vue();
